<template>
  <div class="d-flex align-item-end" v-if="user">
    <div class="d-flex align-items-center">
      <UserImage :image="user.image" />

      <a :href="user.link" class="text-body ms-5px text-decoration-none text-primary-hover fw-bolder">
        <small>{{ user.name }}</small>
      </a>
    </div>

    <small class="fs-sm ms-auto">{{ created }}</small>
  </div>

  <div class="d-flex align-item-end" v-if="!user">
    <div class="d-flex align-items-center">
      <UserImage />

      <span class="text-body ms-5px text-decoration-none fw-bolder">
       <small>RapBack</small>
      </span>
    </div>

    <small class="fs-sm ms-auto">{{ created }}</small>
  </div>
</template>

<script>
import UserImage from "./UserImage.vue";

export default {
  name: "UserCreationPanel",
  components: { UserImage },
  props: {
    user: {
      type: Object,
      required: false,
      default: null,
    },
    created: String
  },
}
</script>
